import axios from 'axios';
import { API_URL } from '../config/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const siteSettingsService = {
  // Get public site settings (for displaying on site)
  getPublicSettings: async () => {
    const response = await api.get('/settings/site/public');
    return response.data;
  },

  // Get all site settings (admin only)
  getSettings: async () => {
    const response = await api.get('/settings/site');
    return response.data?.settings || response.data;
  },

  // Update site settings (admin only)
  updateSettings: async (data) => {
    const response = await api.put('/settings/site', data);
    return response.data;
  },

  // Get all social media links
  getSocialLinks: async () => {
    const response = await api.get('/settings/social-links');
    return response.data;
  },

  // Create a social media link
  createSocialLink: async (data) => {
    const response = await api.post('/settings/social-links', data);
    return response.data;
  },

  // Update a social media link
  updateSocialLink: async (id, data) => {
    const response = await api.put(`/settings/social-links/${id}`, data);
    return response.data;
  },

  // Delete a social media link
  deleteSocialLink: async (id) => {
    const response = await api.delete(`/settings/social-links/${id}`);
    return response.data;
  },

  // Toggle visibility of a social media link
  toggleSocialLinkVisibility: async (id) => {
    const response = await api.patch(`/settings/social-links/${id}/visibility`);
    return response.data;
  }
};

export default siteSettingsService;
